import * as React from 'react';

function SvgInstagram(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.99 23.99" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M23.97 10.96a3 3 0 000-.31H19.1a7.3 7.3 0 01-7 8.64 7 7 0 01-5-1.88 7.22 7.22 0 01-2.3-6.76H.02v9.4a6.51 6.51 0 00.06.88 3.82 3.82 0 003.82 3.03c5.39-.05 10.79 0 16.19 0a4.69 4.69 0 00.92-.07 3.79 3.79 0 003-3.87c-.04-3.06-.04-6.06-.04-9.06zM-.03 7.76h6a.35.35 0 00.25-.15 6.62 6.62 0 015.23-2.9 6.9 6.9 0 016.35 2.85.48.48 0 00.42.21h5.75V3.74a3.63 3.63 0 00-.48-1.88 3.7 3.7 0 00-3.38-1.9H3.5A3.64 3.64 0 00.03 3.42C-.03 4.61-.03 5.8-.03 6.96zm18.71-5.2a.55.55 0 01.6-.62h2.17c.4 0 .57.22.59.63s0 .71 0 1.07v1c0 .35-.21.66-.65.67h-2a.71.71 0 01-.69-.75c-.04-.67-.03-1.33-.02-2z" />
      <path d="M7.53 11.96a4.46 4.46 0 108.92 0 4.46 4.46 0 00-8.92 0z" />
    </svg>
  );
}

const MemoSvgInstagram = React.memo(SvgInstagram);
export default MemoSvgInstagram;
